// schema
import * as ISchema from "@schema";
// libraries
import React from "react";

// components
import { TeamSections } from "../web-settings";

import { TeamSettingsAdminTeamCalendar } from "@components/teams-settings/team-settings-admin-form/team-settings-admin-team-calendar";

// material-ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Team Availability Calendar Settings
// ~-~-~-~-~-~-~-
interface TeamAvailabilityCalendarProps {
  org: ISchema.IOrg;
  team: ISchema.ITeam;
}

const useStyles = makeStyles({
  content: {
    marginBottom: 30,
  },
});

export const TeamAvailabilityCalendar = (props: TeamAvailabilityCalendarProps) => {
  const classes = useStyles();

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  const { org, team } = props;

  return (
    <div
      cw-id={`web-settings-${TeamSections.TeamAvailabilityCalendar}`}
      className={classes.content}
    >
      <Typography variant="h3" className="cw-mb-4">
        Team Availability Calendar
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        Clockwise automatically syncs individual team member's “Out of office / unavailable” events
        to a shared team calendar to help the team stay informed about everyone's availability at a
        glance.{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Learn more
        </a>
        .
      </Typography>
      <TeamSettingsAdminTeamCalendar org={org} team={team} isWebSettings />
    </div>
  );
};
